function Separator(props) {
  return (
    <div className="separator-container">
      {props.children}
    </div>
  );
}

export default Separator;
